/* TheArtFolio predictive search */
(function () {
  "use strict";

  var RECENT_KEY = "artfolio-recent-searches";
  var RECENT_LIMIT = 6;
  var DEBOUNCE_MS = 220;
  var SUGGEST_LIMIT = 6;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(cents);
    }
    var value = (Number(cents) || 0) / 100;
    return "£" + value.toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean).slice(0, RECENT_LIMIT) : [];
    } catch (e) {
      return [];
    }
  }

  function setRecent(list) {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_LIMIT)));
    } catch (e) {}
  }

  function pushRecent(term) {
    term = String(term || "").trim();
    if (!term) return;
    var next = [term].concat(getRecent().filter(function (item) {
      return item.toLowerCase() !== term.toLowerCase();
    }));
    setRecent(next);
  }

  function productImage(product) {
    if (product.image) return product.image;
    if (product.featured_image) {
      return typeof product.featured_image === "string"
        ? product.featured_image
        : product.featured_image.url || product.featured_image.src || "";
    }
    return "";
  }

  function productPrice(product) {
    var cents = product.price_min != null ? product.price_min : product.price;
    if (cents == null || cents === "") return "";
    var n = Number(cents);
    if (!isFinite(n)) return String(cents);
    // Already a decimal currency string (rare).
    if (String(cents).indexOf(".") !== -1 && n < 100000) {
      return "from £" + n.toFixed(2);
    }
    return "from " + formatMoney(n);
  }

  ready(function () {
    var root = document.querySelector("[data-predictive-search]");
    if (!root) return;

    var backdrop = document.querySelector("[data-search-backdrop]");
    var openers = document.querySelectorAll("[data-search-open]");
    var closeBtns = root.querySelectorAll("[data-search-close]");
    var form = root.querySelector("[data-search-form]");
    var input = root.querySelector("[data-search-input]");
    var clearBtn = root.querySelector("[data-search-clear]");
    var idle = root.querySelector("[data-search-idle]");
    var results = root.querySelector("[data-search-results]");
    var resultsInner = root.querySelector("[data-search-results-inner]");
    var footer = root.querySelector("[data-search-footer]");
    var viewAll = root.querySelector("[data-search-view-all]");
    var status = root.querySelector("[data-search-status]");
    var recentWrap = root.querySelector("[data-search-recent]");
    var recentList = root.querySelector("[data-search-recent-list]");
    var clearRecentBtn = root.querySelector("[data-search-clear-recent]");
    var searchUrl = (form && form.getAttribute("action")) || "/search";

    var debounceTimer = 0;
    var activeController = null;
    var lastOpener = null;
    var activeIndex = -1;
    var resultNodes = [];

    function isOpen() {
      return root.getAttribute("data-open") === "true";
    }

    function setStatus(message) {
      if (status) status.textContent = message || "";
    }

    function renderRecent() {
      if (!recentWrap || !recentList) return;
      var items = getRecent();
      if (!items.length) {
        recentWrap.hidden = true;
        recentList.innerHTML = "";
        return;
      }
      recentWrap.hidden = false;
      recentList.innerHTML = items.map(function (term) {
        return '<li><button type="button" class="predictive-search-chip" data-search-suggestion="' +
          escapeHtml(term) + '">' + escapeHtml(term) + "</button></li>";
      }).join("");
    }

    function showIdle() {
      if (idle) idle.hidden = false;
      if (results) results.hidden = true;
      if (footer) footer.hidden = true;
      resultNodes = [];
      activeIndex = -1;
    }

    function showResults() {
      if (idle) idle.hidden = true;
      if (results) results.hidden = false;
    }

    function updateClear() {
      if (!clearBtn || !input) return;
      clearBtn.hidden = !String(input.value || "").trim();
    }

    function setActive(index) {
      resultNodes.forEach(function (node) {
        node.classList.remove("is-active");
      });
      if (index < 0 || index >= resultNodes.length) {
        activeIndex = -1;
        return;
      }
      activeIndex = index;
      var node = resultNodes[activeIndex];
      node.classList.add("is-active");
      node.focus({ preventScroll: false });
      node.scrollIntoView({ block: "nearest" });
    }

    function collectResultNodes() {
      resultNodes = Array.prototype.slice.call(
        root.querySelectorAll("[data-search-result-item]")
      );
      activeIndex = -1;
    }

    function renderEmpty(term) {
      var discover = root.querySelector('.predictive-search-links a[href*="discover"]');
      var discoverHref = discover ? discover.getAttribute("href") : "/pages/discover";
      resultsInner.innerHTML =
        '<div class="predictive-search-empty">' +
        "No matches for <strong>" + escapeHtml(term) + "</strong>. " +
        'Try another word, or <a href="' + escapeHtml(discoverHref) + '">explore Discover</a>.' +
        "</div>";
      if (footer) footer.hidden = true;
      if (viewAll) {
        viewAll.href = searchUrl + "?q=" + encodeURIComponent(term) + "&type=product";
      }
      collectResultNodes();
      setStatus("No results for " + term);
    }

    function renderSuggestions(payload, term) {
      var resources = (payload && payload.resources && payload.resources.results) || {};
      var products = resources.products || [];
      var collections = resources.collections || [];
      var pages = resources.pages || [];
      var articles = resources.articles || [];
      var html = "";
      var total =
        products.length + collections.length + pages.length + articles.length;

      if (!total) {
        renderEmpty(term);
        return;
      }

      if (products.length) {
        html += '<div class="predictive-search-group">';
        html += '<h3 class="predictive-search-group-title">Works</h3>';
        html += '<ul class="predictive-search-products">';
        products.forEach(function (product) {
          var img = productImage(product);
          var price = productPrice(product);
          html +=
            '<li><a class="predictive-search-product" href="' + escapeHtml(product.url) + '" data-search-result-item>' +
            '<span class="predictive-search-product-media">' +
            (img
              ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title || "Artwork") + '" width="320" height="400" loading="lazy">'
              : "") +
            "</span>" +
            '<span class="predictive-search-product-copy">' +
            '<span class="predictive-search-product-title">' + escapeHtml(product.title) + "</span>" +
            (product.vendor
              ? '<span class="predictive-search-product-meta">' + escapeHtml(product.vendor) + "</span>"
              : "") +
            (price
              ? '<span class="predictive-search-product-price">' + escapeHtml(price) + "</span>"
              : "") +
            "</span></a></li>";
        });
        html += "</ul></div>";
      }

      function rows(title, items, typeLabel) {
        if (!items.length) return "";
        var block =
          '<div class="predictive-search-group">' +
          '<h3 class="predictive-search-group-title">' + escapeHtml(title) + "</h3>" +
          '<ul class="predictive-search-rows">';
        items.forEach(function (item) {
          block +=
            '<li><a class="predictive-search-row" href="' + escapeHtml(item.url) + '" data-search-result-item>' +
            '<span class="predictive-search-row-title">' + escapeHtml(item.title) + "</span>" +
            '<span class="predictive-search-row-type">' + escapeHtml(typeLabel) + "</span>" +
            "</a></li>";
        });
        block += "</ul></div>";
        return block;
      }

      html += rows("Collections", collections, "Collection");
      html += rows("Pages", pages, "Page");
      html += rows("Journal", articles, "Article");

      resultsInner.innerHTML = html;
      if (footer) footer.hidden = false;
      if (viewAll) {
        viewAll.href = searchUrl + "?q=" + encodeURIComponent(term) + "&type=product";
        viewAll.textContent = 'View all results for “' + term + '” →';
      }
      collectResultNodes();
      setStatus(total + " suggestions for " + term);
    }

    function fetchSuggestions(term) {
      if (activeController) activeController.abort();
      activeController = "AbortController" in window ? new AbortController() : null;

      var params = new URLSearchParams();
      params.set("q", term);
      params.set("resources[type]", "product,collection,page,article");
      params.set("resources[limit]", String(SUGGEST_LIMIT));
      params.set("resources[limit_scope]", "each");
      params.set("resources[options][unavailable_products]", "last");
      params.set("resources[options][fields]", "title,product_type,variants.title,vendor,tag");

      var url = searchUrl + "/suggest.json?" + params.toString();
      var opts = { headers: { Accept: "application/json" } };
      if (activeController) opts.signal = activeController.signal;

      setStatus("Searching…");
      return fetch(url, opts)
        .then(function (res) {
          if (!res.ok) throw new Error("Suggest failed");
          return res.json();
        })
        .then(function (data) {
          showResults();
          renderSuggestions(data, term);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          showResults();
          resultsInner.innerHTML =
            '<div class="predictive-search-empty">Something went wrong. <a href="' +
            escapeHtml(searchUrl + "?q=" + encodeURIComponent(term)) +
            '">Search the full catalogue →</a></div>';
          if (footer) footer.hidden = true;
          setStatus("Search error");
        });
    }

    function onQueryChange() {
      updateClear();
      var term = String(input.value || "").trim();
      if (debounceTimer) window.clearTimeout(debounceTimer);
      if (!term) {
        if (activeController) activeController.abort();
        showIdle();
        setStatus("");
        return;
      }
      debounceTimer = window.setTimeout(function () {
        fetchSuggestions(term);
      }, DEBOUNCE_MS);
    }

    function openSearch(opener) {
      lastOpener = opener || document.activeElement;
      root.hidden = false;
      if (backdrop) backdrop.hidden = false;
      root.setAttribute("aria-hidden", "false");
      root.removeAttribute("inert");
      document.documentElement.classList.add("search-lock");
      openers.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "true");
      });
      renderRecent();
      updateClear();
      window.requestAnimationFrame(function () {
        root.setAttribute("data-open", "true");
        if (input) input.focus();
      });
    }

    function closeSearch() {
      root.setAttribute("data-open", "false");
      root.setAttribute("aria-hidden", "true");
      root.setAttribute("inert", "");
      if (backdrop) backdrop.hidden = true;
      document.documentElement.classList.remove("search-lock");
      openers.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
      });
      window.setTimeout(function () {
        if (!isOpen()) root.hidden = true;
      }, 280);
      if (lastOpener && document.contains(lastOpener) && lastOpener.focus) {
        lastOpener.focus();
      }
    }

    function applySuggestion(term) {
      if (!input) return;
      input.value = term;
      updateClear();
      pushRecent(term);
      renderRecent();
      fetchSuggestions(term);
      showResults();
      input.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        if (isOpen()) closeSearch();
        else openSearch(btn);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener("click", closeSearch);
    });
    if (backdrop) backdrop.addEventListener("click", closeSearch);

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        input.value = "";
        updateClear();
        showIdle();
        setStatus("");
        input.focus();
      });
    }

    if (clearRecentBtn) {
      clearRecentBtn.addEventListener("click", function () {
        setRecent([]);
        renderRecent();
      });
    }

    if (input) {
      input.addEventListener("input", onQueryChange);
      input.addEventListener("keydown", function (event) {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          if (!resultNodes.length) return;
          setActive(activeIndex < 0 ? 0 : Math.min(activeIndex + 1, resultNodes.length - 1));
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          if (!resultNodes.length) return;
          setActive(activeIndex <= 0 ? resultNodes.length - 1 : activeIndex - 1);
        } else if (event.key === "Escape") {
          event.preventDefault();
          closeSearch();
        }
      });
    }

    if (form) {
      form.addEventListener("submit", function () {
        var term = String(input.value || "").trim();
        if (term) pushRecent(term);
      });
    }

    root.addEventListener("click", function (event) {
      var suggestion = event.target.closest("[data-search-suggestion]");
      if (suggestion) {
        event.preventDefault();
        applySuggestion(suggestion.getAttribute("data-search-suggestion") || suggestion.textContent);
        return;
      }
      var item = event.target.closest("[data-search-result-item]");
      if (item) {
        var term = String(input.value || "").trim();
        if (term) pushRecent(term);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) {
        event.preventDefault();
        closeSearch();
        return;
      }
      // Focus search with "/" when not typing in a field
      if (
        event.key === "/" &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.altKey &&
        !isOpen()
      ) {
        var tag = (event.target && event.target.tagName) || "";
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(tag) || event.target.isContentEditable) return;
        event.preventDefault();
        openSearch(openers[0] || null);
      }
    });

    renderRecent();
    showIdle();
  });
})();
